import { Tooltip } from 'components/Tooltip/Tooltip';
import {
  EXCHANGE_RATE_DECIMAL_POSITIONS,
  MARKUP_RATE_DECIMAL_POSITIONS,
} from 'constants/index';
import React from 'react';
import { useTranslations } from 'utils';

import './FXInfo.scss';

type FXInfoProps = {
  exchangeRate?: number;
  id?: string;
  markupRate?: number;
};

const FXInfoComponent = ({ exchangeRate, markupRate, id }: FXInfoProps) => {
  const i18n = useTranslations();
  const roundedMarkupRate =
    markupRate && markupRate.toFixed(MARKUP_RATE_DECIMAL_POSITIONS);
  const roundedExchangeRate =
    exchangeRate && exchangeRate.toFixed(EXCHANGE_RATE_DECIMAL_POSITIONS);

  return (
    <Tooltip.Info id={`fxInfo-description-${id}`} position="bottom-end">
      <ul className="Offer-FXInfo">
        <li data-testid="markupRate">
          {`${i18n.t(
            'checkout.paymentOptions.fxInfo.markupRate',
          )}: ${roundedMarkupRate} %`}
        </li>
        <li data-testid="exchangeRate">
          {`${i18n.t(
            'checkout.paymentOptions.fxInfo.exchangeRate',
          )}: ${roundedExchangeRate}`}
        </li>
      </ul>
    </Tooltip.Info>
  );
};

export const FXInfo = React.memo(FXInfoComponent);
